// Popover de idioma (mockup Aeros): código em caixa, nome, check no ativo.
// Troca sem recarregar a página (i18n.changeLanguage + localStorage).
import React, { useState } from "react";
import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import TranslateIcon from "@material-ui/icons/Translate";
import CheckIcon from "@material-ui/icons/Check";
import { i18n } from "../../translate/i18n";
import { AEROS } from "../../styles/aerosTokens";
import useHeaderStyles from "./headerStyles";
import { LANGUAGES, langShort } from "./headerRules";

export default function LanguagePopover({ enabled = ["pt-BR", "en"], onChange }) {
  const h = useHeaderStyles();
  const [anchor, setAnchor] = useState(null);
  const current = i18n.language || localStorage.getItem("language") || "pt-BR";
  const list = LANGUAGES.filter((l) => enabled.includes(l.code));
  return (
    <>
      <Tooltip title={`${i18n.t("aeros.header.language")} · ${langShort(current)}`}>
        <IconButton className={`${h.iconBtn} ${anchor ? h.iconBtnOn : ""}`} onClick={(e) => setAnchor(e.currentTarget)} aria-label={i18n.t("aeros.header.language")}>
          <TranslateIcon /><span className={h.code}>{langShort(current)}</span>
        </IconButton>
      </Tooltip>
      <Popover open={Boolean(anchor)} anchorEl={anchor} onClose={() => setAnchor(null)} classes={{ paper: h.paper }} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}>
        <div className={h.pad} style={{ width: 240 }}>
          {list.map((l) => (
            <button key={l.code} type="button" className={`${h.row} ${l.code === current ? h.rowOn : ""}`} onClick={() => { onChange(l.code); setAnchor(null); }}>
              <span style={{ fontSize: 10.5, fontWeight: 800, letterSpacing: "0.06em", width: 36, border: "1px solid rgba(128,128,128,0.35)", borderRadius: 5, textAlign: "center", padding: "2px 0", flex: "none" }}>{l.short}</span>
              <span style={{ flex: 1 }}>{l.label}</span>
              {l.code === current && <CheckIcon style={{ color: AEROS.cyan, fontSize: 16 }} />}
            </button>
          ))}
          <div className={h.hint}>{i18n.t("aeros.header.languageHint")}</div>
        </div>
      </Popover>
    </>
  );
}
